import React, { useState } from 'react'
import { Button, Checkbox, Radio } from 'antd'
import styles from './style.module.scss'

// 내보내기 첫 모달의 형식 선택(spec D1). 선택은 state 가 아니라 호출부가 만든 formatRef 에 적는다 —
// runExportFlow 가 [예]를 누른 시점에 formatRef.value 를 읽어 CSV 면 암호화 단계를 건너뛴다.
//
// frontend/CLAUDE.md 는 antd 네임스페이스 컴포넌트를 import 뒤 destructuring 하라고 하지만, 이 모듈은
// bulkExport.js 를 거쳐 antd 를 Radio 없이 mock 한 기존 시험에도 로드된다(bulkExport.test.js:34).
// 모듈 최상위에서 꺼내면 그 시험들이 로드 단계에서 깨지므로 컴포넌트 본문에서 꺼낸다.
const ExportFormatField = ({ t, formatRef }) => {
  const { Group } = Radio
  return (
    <div className={styles.formatField}>
      <div className={styles.formatLabel}>{t('record.desc.exportFormat')}</div>
      <Group
        className={styles.formatGroup}
        defaultValue={formatRef.value}
        onChange={(e) => {
          formatRef.value = e.target.value
        }}
      >
        <Radio value="json">{t('record.desc.exportFormatJson')}</Radio>
        <Radio value="csv">{t('record.desc.exportFormatCsv')}</Radio>
      </Group>
    </div>
  )
}

// CSV 로 내보낼 템플릿 고르기(spec D8, CSV 전용 — 템플릿이 2종 이상일 때만 뜬다). 선택 상태는 이 컴포넌트가 들고,
// 확인·취소 버튼도 여기 둔다 — 버튼이 모달을 만드는 쪽(bulkExport.js)에 있으면 이 컴포넌트를 렌더하는 시험이 [내보내기]의
// disabled 를 볼 수 없다(실제 antd 로 두 구조를 실행해 확인, audit §A7).
// groups: [{ key, name, count }] — onConfirm 은 선택된 key 를 groups 순서로 넘긴다
export const TemplateSelectContent = ({ t, groups, onConfirm, onCancel }) => {
  const [selected, setSelected] = useState(() => groups.map((group) => group.key))
  const toggle = (key, checked) =>
    setSelected((previous) =>
      checked ? [...previous, key] : previous.filter((selectedKey) => selectedKey !== key),
    )
  return (
    <div className={styles.templateSelect}>
      <div className={styles.templateSelectDesc}>{t('record.desc.exportCsvSelectTemplates')}</div>
      <div className={styles.templateList}>
        {groups.map((group) => (
          <Checkbox
            key={group.key}
            checked={selected.includes(group.key)}
            onChange={(e) => toggle(group.key, e.target.checked)}
          >
            {t('record.desc.exportCsvTemplateOption', { name: group.name, n: group.count })}
          </Checkbox>
        ))}
      </div>
      {selected.length === 0 && (
        <div className={styles.templateSelectHint}>
          {t('record.desc.exportCsvSelectAtLeastOne')}
        </div>
      )}
      <div className={styles.templateSelectFooter}>
        {/* 전역 규칙이 antd 버튼(text 버튼 제외)을 흰 바탕으로 만들어(officemail.scss:482-495) 주 버튼은 type8 이 있어야 어둡게 나온다 */}
        <Button className="w100 h38" onClick={onCancel}>
          {t('common.button.cancel')}
        </Button>
        <Button
          type="primary"
          className="type8 w100 h38"
          disabled={selected.length === 0}
          onClick={() =>
            onConfirm(groups.map((group) => group.key).filter((key) => selected.includes(key)))
          }
        >
          {t('record.button.export')}
        </Button>
      </div>
    </div>
  )
}

export default ExportFormatField
